import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { BankPaymentView } from '../../originators/BankPaymentView'
import { BillDrawerView } from '../../originators/BillDrawerView'
import { ContactBalancePaymentView } from '../../originators/ContactBalancePaymentView'
import { ConversionBalanceView } from '../../originators/ConversionBalanceView'
import { DaybookTransactionView } from '../../originators/DaybookTransactionView'
import { ExternalInvoiceView } from '../../originators/ExternalInvoiceView'
import { InvoiceLateFeeView } from '../../originators/InvoiceLateFeeView'
import { InvoiceView } from '../../originators/InvoiceView'
import { VatReturnPaymentView } from '../../originators/VatReturnPaymentView'
import { VatReturnView } from '../../originators/VatReturnView'
import { TransactionDrawerSkeleton } from '../TransactionDrawerSkeleton'

export const TransactionDrawerBody = () => {
  const { isLoading, originatorResult, transactionNo } = useTransactionDrawerContext()

  if (isLoading) {
    return <TransactionDrawerSkeleton transactionNo={transactionNo} />
  }

  if (!originatorResult.originator) {
    return null
  }

  switch (originatorResult.type) {
    case TransactionOriginatorType.Bill:
      return <BillDrawerView bill={originatorResult.originator} />

    case TransactionOriginatorType.BankPayment:
      return <BankPaymentView bankPayment={originatorResult.originator} />

    case TransactionOriginatorType.Invoice:
      return <InvoiceView invoice={originatorResult.originator} />

    case TransactionOriginatorType.SalesTaxReturn:
      return <VatReturnView vatReturn={originatorResult.originator} />

    case TransactionOriginatorType.SalesTaxPayment:
      return <VatReturnPaymentView vatReturnPayment={originatorResult.originator} />

    case TransactionOriginatorType.ContactBalancePayment:
      return <ContactBalancePaymentView contactBalancePayment={originatorResult.originator} />

    case TransactionOriginatorType.ConversionBalance:
      return <ConversionBalanceView />

    case TransactionOriginatorType.InvoiceLateFee:
      return <InvoiceLateFeeView invoiceLateFee={originatorResult.originator} />

    case TransactionOriginatorType.DaybookTransaction:
      return <DaybookTransactionView daybookTransaction={originatorResult.originator} />

    case TransactionOriginatorType.ExternalInvoice:
      return <ExternalInvoiceView invoice={originatorResult.originator} />

    default:
      return null
  }
}
